import { render, staticRenderFns } from "./consulting02.vue?vue&type=template&id=799e93e7&scoped=true"
import script from "./consulting02.vue?vue&type=script&lang=js"
export * from "./consulting02.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799e93e7",
  null
  
)

export default component.exports